
import ActiveEvents from '../../assets/img/activeEvents.svg';
import PastEvents from '../../assets/img/pastEvents.svg';
import NoEvents from '../../assets/img/noEvents.svg';
import CalendarWhiteEvents from '../../assets/img/calendarWhiteEvents.svg';
import Plus from '../../assets/img/plusSmallWhite.svg';
import { useState, useEffect } from "react";
import { DateExapmle} from "../CreateEvent/components/DateAndTime";
import CalendarSmallWhite from "../../assets/img/calendarSmallWhite.svg";
import { useFormik } from "formik";
import DrawerUI from "../../components/ui/Drawer";
import { useNavigate } from 'react-router-dom';
import { UserMenu } from '../../components';
import { StorageService } from '../../application/services';
import { ServiceProxy } from '../../ServiceProxy';
import { MyEventCard } from '../../components';
import { pageSize } from '../../config';
import { Overlay } from '../../components';
import { withErrorHandler } from '../../components';
import { message } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { ca } from 'date-fns/locale';

const StatisticsPage = () => {
    const navigate = useNavigate()
    const [toggle, setToggle] = useState(1)
    const [close, setClose] = useState(false)
    const [events, setEvents] = useState([])
    const [pastEvents, setPastEvents] = useState([])
    const [organizationStatistics, setOrganizationStatistics] = useState({})
    const [organizationList, setOrganizationList] = useState([])
    const [filterParams, setFilterParams] = useState({})
    const formik = useFormik({
        initialValues: {
            date: ''
        },
        onSubmit: values => {
            console.log(values);
        },
    });
    const [loading, setLoading] = useState(true)
    const [messageApi, contextHolder] = message.useMessage();
    const logout = () => {
        StorageService.clear()
        navigate('/')
    }
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'start_date' || filterType === 'end_date') {
            value = dayjs(value).format('YYYY-MM-DD')
        }
        if (filterType === 'event' && value === 'null') {
            value = null
        }
        setFilterParams((prevState) => ({
            ...prevState,
            [filterType]: value, // Dynamically update the filter type
        }));
    };

    const formateYAxis = (value) => {
        if (!value) return []
        return Object.entries(value).map(([key, val]) => ({name: key, y: val, drilldown: key}))
    }

    const chartOptions = {
        title: {
          text: 'Revenue'
        },
        xAxis: {
            categories: organizationStatistics.last_six_months_revenue ? Object.keys(organizationStatistics.last_six_months_revenue) : [],
          },
        yAxis: {
            title: {
                text: ''
            }
        },
        series: [{
            type: 'column',
            data: formateYAxis(organizationStatistics.last_six_months_revenue),
            // data: organizationStatistics.last_six_months_revenue ? Object.values(organizationStatistics.last_six_months_revenue) : [],
        }],
        legend: {
            enabled: false // Disable the legend
        },
        tooltip: {
            headerFormat: '', // Remove the series name from the tooltip header
            pointFormat: '<b>{point.category}:</b> {point.y}'  // Customize the tooltip to only show the value
        }
    }

    const getActiveEvents = () => {
        ServiceProxy.EventsService.getUserEvents({ is_active: true })
            .then(response => {
                if (response && response.data) {
                    const result = response.data.results
                    setEvents(result)
                }
            })
            .catch(e => {
                console.error({ e })
                setLoading(false)
            })
    }

    const getOrganizationStatistics = () => {
        ServiceProxy.StatisticsService.getStatistics(filterParams)
            .then(response => {
                if (response && response.data) {
                    const result = response.data
                    setOrganizationStatistics(result)
                    setLoading(false)
                }
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            })
    }
    // const getLastSixMonthsRevenue = () => {
    //     ServiceProxy.StatisticsService.getLastSixMonthsRevenue()
    //         .then(response => {
    //             if (response && response.data) {
    //                 const result = response.data
    //                 setOrganizationStatistics(prevState => ({
    //                     ...prevState,
    //                     last_six_months_revenue: result
    //                 }));
    //                 setLoading(false)
    //             }
    //         })
    //         .catch(e => {
    //             console.error(e);
    //             setLoading(false);
    //         })
    // }

    useEffect(() => {
        getActiveEvents();
        getOrganizationStatistics();
        // getLastSixMonthsRevenue()
    }, [filterParams]);// eslint-disable-line react-hooks/exhaustive-deps


    
    return (
        <div className="container-fluid">
            {contextHolder}
            <div className="row">
                <DrawerUI className='drawer' activeTab={5} activeItem={5} openList={5} close={close} setClose={setClose} style={{ width: close && '5rem' }} />
                {loading ? <Overlay /> :
                    <div className={close ? "col width-colum" : "col drawer-in-small width-colum"}>
                        <div className="my-events container">
                            <div>
                                <div className="row">
                                    <div className='d-flex gap-2 navUser justify-content-end m-1'>
                                        <UserMenu logout={logout} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <p className='create-title'><img src={CalendarWhiteEvents} alt="CalendarWhiteEvents" />My Statistics</p>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-3">
                                        <select className="form-select" onChange={(e) => handleFilterChange('event', e.target.value)}>
                                            <option key="null" value="null" selected={filterParams.event === null}>All events</option>
                                            {events.map((org) => (
                                                <option key={org.id} value={org.id}>{org.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-3">
                                        <DateExapmle label={'From Date'}
                                            placeholder={'DD/MM/YYYY'}
                                            disabledDate={() => false}
                                            icon={<img src={CalendarSmallWhite} alt="CalendarSmallWhite" />}
                                            name="fromDate"
                                            onChange={(date) => handleFilterChange('start_date', date)}
                                            value={formik.values.fromDate} />
                                    </div>
                                    <div className="col-3">
                                        <DateExapmle label={'To Date'}
                                            placeholder={'DD/MM/YYYY'}
                                            disabledDate={() => false}
                                            icon={<img src={CalendarSmallWhite} alt="CalendarSmallWhite" />}
                                            name="toDate"
                                            onChange={(date) => handleFilterChange('end_date', date)}
                                            value={formik.values.toDate} />
                                    </div>
                                    <div>
                                    <div>
                                        <p>Total Sold Tickets: {organizationStatistics.total_sold_tickets}</p>
                                        <p>Available Tickets by Type: {JSON.stringify(organizationStatistics.available_tickets_by_type)}</p>
                                        <p>Total Revenue: {organizationStatistics.total_revenue}</p>
                                        <p>Last Six Months Revenue: {JSON.stringify(organizationStatistics.last_six_months_revenue)}</p>
                                    </div>
                                    </div>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={chartOptions}
                                    />
                                    


                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export const Statistics = withErrorHandler(StatisticsPage, axios);
